import styled from "styled-components";
import { Input } from "@mui/material";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f7f2fa;
`;
export const StyledInput = styled(Input)`
  && {
    border: 1px solid #bbbbbb;
    outline: none;
    background-color: #ffffff;
    font-family: DM Sans;
    font-size: 12px;
    font-weight: 400;
    color: #565556;
    width: 45px;
    height: 40px;
    border-radius: 5px;
    padding-left: 10px;
    margin-left: 30px;
    &:focus {
      border: none;
      outline: none;
    }

    &::before,
    &::after {
      display: none; // Removes underline on focus and in general
    }
  }
`;

export const StyledInput2 = styled(Input)`
  && {
    border: 1px solid #bbbbbb;
    outline: none;
    background-color: #ffffff;
    font-family: DM Sans;
    font-size: 11px;
    font-weight: 500;
    color: #565556;
    width: 40px;
    height: 40px;
    border-radius: 5px;
    padding-left: 5px;
    margin-left: 30px;
    height: 24px;
    &:focus {
      border: none;
      outline: none;
    }

    &::before,
    &::after {
      display: none; // Removes underline on focus and in general
    }
  }
`;
export const CornerHeading = styled.p`
  font-size: 16px;
  color: #000000;
  font-family: DM Sans;
  font-weight: 500;
  margin-right: 10px;
  margin-top: 8px;
`;

export const PxText = styled.p`
  font-size: 14px;
  color: #565556;
  font-family: DM Sans;
  font-weight: 400;
  margin-left: 5px;
  margin-top: 8px;
  margin-right: 10px;
`;

export const PxText2 = styled.p`
  font-size: 14px;
  color: #565556;
  font-family: DM Sans;
  font-weight: 400;
  text-align: center;
  margin: 0;
`;

export const RowDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .rc-slider-disabled {
    background-color: transparent;
  }
`;

export const Flexy = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
`;

export const FlexyBaka = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const SliderHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
